<template>
    <div>
        <h3 class="mb-3">{{ $t('flags') }}</h3>
        
        <div v-for="flag in flags" :key="`flag-${flag.id}`" class="mb-3">

            <label>{{ flag.name }}</label>

            <div class="d-flex flex-row">
                <div v-for="value in flag.values" :key="`value-${value.id}`" class="d-flex flex-row align-items-center bg-white rounded border p-1 mr-2 mb-2">
                    <input type="checkbox" class="form-check mr-2" :checked="hasFlag(flag.id, value.value)" @click="toggleFlag(flag.id, value.value)"/>
                    <div class="userflag p-3" :class="value.value"></div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    props: {
        user: Object,
    },
    mounted() {
        this.fetchFlags()
    },
    data() {
        return {
            flags: [],
        }
    },
    methods: {
        async fetchFlags() {
            const storedFlags = sessionStorage.getItem('userflagvalues')

            if (storedFlags) {
                this.flags = JSON.parse(storedFlags)
                return
            }

            try {
                const res = await this.$cfetch(`${this.$settings.APIBaseURL}/flags/all`, { method: 'GET' })

                if (res.status !== 'SUCCESS') return

                this.flags = res.flags

                sessionStorage.setItem('flags', JSON.stringify(this.flags))
            } catch (err) {
                this.$log.error.call(this, err)
            }
        },
        hasFlag(property_id, value) {
            return this.user.flags.findIndex(flag => flag.property_id === property_id && flag.value === value) > -1
        },
        toggleFlag(property_id, value) {
            if (this.hasFlag(property_id, value)) this.user.flags = this.user.flags.filter(flag => !(flag.property_id === property_id && flag.value === value))
            else this.user.flags.push({ property_id, value })
        },
    }
}
</script>